<template>
  <footer class="dashboard-footer">
    <div class="dashboard-footer-content">
      <div class="footer-left">
        <div class="copyright">
          &copy; {{ currentYear }} IntegrateMe. All rights reserved.
        </div>
        <span class="divider">|</span>
        <div class="powered-by">
          Powered by&nbsp;<a href="https://customsoftwaresolutions.co.nz/" target="_blank" rel="noopener noreferrer">Custom Software Solutions</a>
        </div>
      </div>
      <div class="footer-links">
        <router-link to="/terms">Terms</router-link>
        <router-link to="/privacy">Privacy</router-link>
        <a href="mailto:support@integrateme.co.nz">Support</a>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped>
.dashboard-footer {
  background-color: var(--white);
  border-top: 1px solid var(--gray-200);
  padding: 1.5rem 0 100px;
  margin-top: auto;
}

.dashboard-footer-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 2rem;
  font-size: 0.875rem;
  color: var(--gray-500);
  gap: 1rem;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.divider {
  color: var(--gray-300);
}

.powered-by a {
  color: var(--gray-600);
  text-decoration: none;
  transition: color 0.2s ease;
  font-weight: 500;
  white-space: nowrap;
}

.powered-by a:hover {
  color: var(--primary);
  text-decoration: underline;
}

.footer-links {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin-top: 0.5rem;
}

.footer-links a {
  color: var(--gray-600);
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: var(--primary);
}

@media (max-width: 768px) {
  .dashboard-footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 1rem;
    gap: 1rem;
  }

  .footer-left {
    flex-direction: column;
    gap: 0.5rem;
  }

  .divider {
    display: none;
  }

  .footer-links {
    justify-content: center;
    gap: 1.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid var(--gray-200);
    margin-top: 0.5rem;
  }
}
</style>
